import { AuthRepository } from '../repositories/AuthRepository';
import { AuthLoginResult } from '../entities/AuthLoginResult';


export class LoginGmail {
  constructor(private repository: AuthRepository) {}

  execute(params: LoginGmailParams): Promise<AuthLoginResult> {
    return this.repository.loginGmail(params.token);
  }
}


export class LoginGmailParams {
  constructor(public token: string) {}
}
